




















import Vue from 'vue'
import store from '../store'
require('typeface-lobster')
export default Vue.extend({
  name: 'Features',
  mounted () {
    let vm = this
    store.commit('setStep', 0)
    setTimeout(function () {
      vm.beginCountdown()
    }, 100)
  },
  data () {
    return {
      questions: [] as string[],
      questions2: [] as string[],
      questions3: [] as string[],
      countdownId: 0,
      countdown: 5,
      randomQuestions: ['<span class="font-semibold underline">Trying to remember</span>', 'Birthdate of friends?', 'Capital of Countries?', 'meaning of Difficult words?', ''],
      randomQuestions2: ['<span class="font-semibold underline">Steps</span>', '1. Add Question & Answer', '2. Revise on New Tab', 'Remember Forever 🌸', ''],
      randomQuestions3: ['<span class="font-semibold underline">Based on science of</span>', 'Spaced Repetition', '& Flash Cards']
    }
  },
  computed: {
  },
  methods: {
    pushToQuestions () {
      let vm = this
      if (vm.randomQuestions.length > 0) {
        vm.questions.push(vm.randomQuestions.shift() as string)
        vm.beginCountdown()
        return
      }
      store.commit('setStep', 1)
      if (vm.randomQuestions2.length > 0) {
        vm.questions2.push(vm.randomQuestions2.shift() as string)
        vm.beginCountdown()
        return
      }
      store.commit('setStep', 2)
      if (vm.randomQuestions3.length > 0) {
        vm.questions3.push(vm.randomQuestions3.shift() as string)
        vm.beginCountdown()
        return
      }
      store.commit('setStep', 3)
    },
    beginCountdown () {
      var vm = this
      if (vm.countdownId !== 0) {
        clearInterval(vm.countdownId)
      }
      vm.countdown = 1
      vm.countdownId = window.setInterval(reduceTime, 1000)
      function reduceTime () {
        vm.countdown -= 1
        if (vm.countdown === 0) {
          clearInterval(vm.countdownId)
          vm.pushToQuestions()
        }
      }
    }
  }
})

